import api from '@services/api'

export default {
  get(axios, params, query, config) {
    return api.get(axios, '/account/profile', params, query, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/account/profile', params, payload, config)
  },
}
